// extracted by mini-css-extract-plugin
export default {"menuList":"MainMenu_menuList__A9zbQ","roomList":"MainMenu_roomList__iFhnp","rooms":"MainMenu_rooms__pXjpu","colorContrast":"MainMenu_colorContrast__vyJoP"};